export var iconVars = {fontSize:'var(--_1pa1mzt0)'};